:host {
  display: block;
  block-size: 100%;
  overflow: auto;
  background-color: var(--ch-color-surface-primary);
  color: var(--ch-color-text-primary);
}

.main {
  overflow: auto;
  display: block;
}

.apis-container {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-xl);
  max-width: 100%;
}

.api-item {
  background: var(--ch-color-surface-secondary);
  border: 1px solid var(--color-border-neutral-default);
  border-radius: 0;
  overflow: hidden;
  transition: all var(--timing-fast) ease;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 64px;

  &:hover {
    box-shadow: var(--color-accent-surface-elevation-2);
    transform: translateY(-2px);
    border-color: var(--color-border-primary-hover);
  }
}

.api-header {
  padding: 16px;
  background: transparent;
  border-bottom: 1px solid var(--color-border-neutral-default);
  flex-shrink: 0;

  .api-name {
    margin: 0;
    color: var(--color-text-neutral-default);
    word-break: break-all;
    overflow-wrap: break-word;
  }
}

.api-content {
  overflow: hidden;
}

.no-apis,
.no-data {
  color: var(--color-text-neutral-disabled);
  font-style: italic;
  text-align: center;
  padding: 16px;

  p {
    font-size: var(--font-size-body-m);
    font-weight: var(--font-style-semi-bold);
    line-height: var(--line-height-spacious);
  }
}
